export default "__VITE_ASSET__B4pNT2Oa__"